module.exports = __webpack_public_path__ + "images/table-view-icon-14170243.svg";